import { IconFileText } from "@tabler/icons-react";
import {
  SupplierInvoice,
  supplierInvoiceFileUrl,
} from "../../api/queries";
import { displayISODate } from "../../utils/display";

interface SupplierInvoiceItemProps {
  invoice: SupplierInvoice;
}

const formatSize = (size?: number | null): string | null => {
  if (!size || size <= 0) return null;
  const kb = size / 1024;
  if (kb < 1024) return `${Math.round(kb)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
};

export const SupplierInvoiceItem = ({ invoice }: SupplierInvoiceItemProps) => {
  const formattedSize = formatSize(invoice.size);

  return (
    <a
      href={supplierInvoiceFileUrl(invoice)}
      target="_blank"
      rel="noreferrer"
      className="flex items-center gap-3 w-full p-2 rounded-lg hover:bg-blue-50 transition-colors text-left group"
    >
      <span className="text-emerald-500 group-hover:text-emerald-600">
        <IconFileText size={18} />
      </span>
      <div className="flex flex-col flex-1 min-w-0">
        <div className="flex items-center gap-2 min-w-0">
          <span className="font-medium text-gray-700 truncate">
            {invoice.filename}
          </span>
          <span className="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ring-1 ring-inset shrink-0 bg-slate-100 text-slate-700 ring-slate-200">
            {invoice.supplier_name}
          </span>
        </div>
        <span className="text-xs text-gray-400 truncate">
          {invoice.subject}
        </span>
      </div>
      <div className="flex flex-col items-end shrink-0">
        <span className="text-sm text-gray-600">
          {displayISODate(invoice.date_sent)}
        </span>
        {formattedSize && (
          <span className="text-xs text-gray-400">{formattedSize}</span>
        )}
      </div>
    </a>
  );
};
